import React from "react";
import { Box } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import { ByzMuiDateTimePicker } from "src/components/core-components/mui/inputs/ByzMuiDateTimePicker";
import ByzMuiSelect from "src/components/core-components/mui/ByzMuiSelect";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";
import ByzMuiTextField from "src/components/core-components/mui/inputs/ByzMuiTextField";

function NihssScoreCreate() {
  return (
    <>
      <Box sx={{ padding: "20px" }}>
        <Grid container spacing={2}>
          <Grid md={9} xs={9} container direction={"column"} spacing={3}>
            <Grid md={6} xs={6} sx={{ backgroundColor: "#F4F7FE" }}>
              <ByzMuiTypography
                sx={{ display: "flex", textAlign: "center" }}
                fontWeight={500}
                fontSize={"14px"}
              >
                NIH İnme Skalası (NIHHS Skoru)
              </ByzMuiTypography>
            </Grid>

            <Grid
              container
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              <Grid md={6} xs={6} sx={{ borderBottom: "1px solid #E0E0E0" }}>
                <ByzMuiTypography>Tarih-Saat</ByzMuiTypography>
              </Grid>
              <Grid md={6} xs={6}>
                <ByzMuiDateTimePicker sx={{ width: "300px" }} />
              </Grid>
            </Grid>

            <Grid
              container
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              <Grid md={6} xs={6} sx={{ borderBottom: "1px solid #E0E0E0" }}>
                <ByzMuiTypography>Kayıt Yapan Kullanıcı</ByzMuiTypography>
              </Grid>

              <Grid md={6} xs={6}>
                <ByzMuiTextField
                  sx={{ width: "300px", backgroundColor: "#F5F5F5" }}
                  color="info"
                  label="Kayıt Yapan Kullanıcı"
                  variant="outlined"
                  disabled
                />
              </Grid>
            </Grid>

            <Grid md={6} xs={6} sx={{ backgroundColor: "#F4F7FE" }}>
              <ByzMuiTypography sx={{ display: "flex", textAlign: "center" }}>
                Parametreler
              </ByzMuiTypography>
            </Grid>

            <Grid md={6} xs={6} sx={{ backgroundColor: "#F4F7FE" }}>
              <ByzMuiTypography sx={{ display: "flex", textAlign: "center" }}>
                1 - Bilinç
              </ByzMuiTypography>
            </Grid>

            <Grid
              container
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              <Grid md={6} xs={6} sx={{ borderBottom: "1px solid #E0E0E0" }}>
                <ByzMuiTypography>1a - Bilinç Düzeyi</ByzMuiTypography>
              </Grid>

              <Grid md={6} xs={6}>
                <ByzMuiSelect
                  renderInput={(params) => (
                    <ByzMuiTextField
                      {...params}
                      label="Ortalama Arter Basıncı"
                      variant="outlined"
                    />
                  )}
                  options={[]}
                  sx={{ width: "235px" }}
                  color="info"
                  label="Seçiniz"
                  placeholder="Seçiniz"
                />
              </Grid>
            </Grid>

            <Grid
              container
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              <Grid md={6} xs={6} sx={{ borderBottom: "1px solid #E0E0E0" }}>
                <ByzMuiTypography
                  sx={{
                    display: "flex",
                    textAlign: "left",
                    paddingLeft: "30px",
                  }}
                >
                  1b - Bilinç Düzeyi Soruları (Kaç Yaşındasın Hangi Aydayız ?)
                </ByzMuiTypography>
              </Grid>

              <Grid md={6} xs={6}>
                <ByzMuiSelect
                  renderInput={(params) => (
                    <ByzMuiTextField
                      {...params}
                      label="Ortalama Arter Basıncı"
                      variant="outlined"
                    />
                  )}
                  options={[]}
                  sx={{ width: "235px" }}
                  color="info"
                  label="Seçiniz"
                  placeholder="Seçiniz"
                />
              </Grid>
            </Grid>

            <Grid
              container
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              <Grid md={6} xs={6} sx={{ borderBottom: "1px solid #E0E0E0" }}>
                <ByzMuiTypography
                  sx={{
                    display: "flex",
                    textAlign: "left",
                    paddingLeft: "30px",
                  }}
                >
                  1c - Bilinç Düzeyi Emirleri (Gözlerini Aç Kapa - Sağlam Eli Aç
                  Kapa)
                </ByzMuiTypography>
              </Grid>

              <Grid md={6} xs={6}>
                <ByzMuiSelect
                  renderInput={(params) => (
                    <ByzMuiTextField
                      {...params}
                      label="Ortalama Arter Basıncı"
                      variant="outlined"
                    />
                  )}
                  options={[]}
                  sx={{ width: "235px" }}
                  color="info"
                  label="Seçiniz"
                  placeholder="Seçiniz"
                />
              </Grid>
            </Grid>

            <Grid
              container
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              <Grid md={6} xs={6} sx={{ borderBottom: "1px solid #E0E0E0" }}>
                <ByzMuiTypography sx={{ display: "flex", textAlign: "left" }}>
                  2 - Bakış
                </ByzMuiTypography>
              </Grid>

              <Grid md={6} xs={6}>
                <ByzMuiSelect
                  renderInput={(params) => (
                    <ByzMuiTextField
                      {...params}
                      label="Ortalama Arter Basıncı"
                      variant="outlined"
                    />
                  )}
                  options={[]}
                  sx={{ width: "235px" }}
                  color="info"
                  label="Seçiniz"
                  placeholder="Seçiniz"
                />
              </Grid>
            </Grid>

            <Grid
              container
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              <Grid md={6} xs={6} sx={{ borderBottom: "1px solid #E0E0E0" }}>
                <ByzMuiTypography sx={{ display: "flex", textAlign: "left" }}>
                  3 - Görme Alanı
                </ByzMuiTypography>
              </Grid>

              <Grid md={6} xs={6}>
                <ByzMuiSelect
                  renderInput={(params) => (
                    <ByzMuiTextField
                      {...params}
                      label="Ortalama Arter Basıncı"
                      variant="outlined"
                    />
                  )}
                  options={[]}
                  sx={{ width: "235px" }}
                  color="info"
                  label="Seçiniz"
                  placeholder="Seçiniz"
                />
              </Grid>
            </Grid>

            <Grid
              container
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              <Grid md={6} xs={6} sx={{ borderBottom: "1px solid #E0E0E0" }}>
                <ByzMuiTypography sx={{ display: "flex", textAlign: "left" }}>
                  4 - Fasiyal Paralizi (Bilinç Kapalı İse Ağrılı Uyarana Yanıt)
                </ByzMuiTypography>
              </Grid>

              <Grid md={6} xs={6}>
                <ByzMuiSelect
                  renderInput={(params) => (
                    <ByzMuiTextField
                      {...params}
                      label="Ortalama Arter Basıncı"
                      variant="outlined"
                    />
                  )}
                  options={[]}
                  sx={{ width: "235px" }}
                  color="info"
                  label="Seçiniz"
                  placeholder="Seçiniz"
                />
              </Grid>
            </Grid>

            <Grid md={6} xs={6} sx={{ backgroundColor: "#F4F7FE" }}>
              <ByzMuiTypography
                sx={{ display: "flex", textAlign: "left" }}
                fontWeight={500}
                fontSize={"14px"}
              >
                5 - Motor(Kollar) Oturarak 90° Yatarak 45° (10 Sn Havada
                Tutulur)
              </ByzMuiTypography>
            </Grid>

            <Grid
              container
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              <Grid md={6} xs={6} sx={{ borderBottom: "1px solid #E0E0E0" }}>
                <ByzMuiTypography>5a - Motor Sol Kol</ByzMuiTypography>
              </Grid>

              <Grid md={6} xs={6}>
                <ByzMuiSelect
                  renderInput={(params) => (
                    <ByzMuiTextField
                      {...params}
                      label="Ortalama Arter Basıncı"
                      variant="outlined"
                    />
                  )}
                  options={[]}
                  sx={{ width: "235px" }}
                  color="info"
                  label="Seçiniz"
                  placeholder="Seçiniz"
                />
              </Grid>
            </Grid>

            <Grid
              container
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              <Grid md={6} xs={6} sx={{ borderBottom: "1px solid #E0E0E0" }}>
                <ByzMuiTypography>5b - Motor Sağ Kol</ByzMuiTypography>
              </Grid>

              <Grid md={6} xs={6}>
                <ByzMuiSelect
                  renderInput={(params) => (
                    <ByzMuiTextField
                      {...params}
                      label="Ortalama Arter Basıncı"
                      variant="outlined"
                    />
                  )}
                  options={[]}
                  sx={{ width: "235px" }}
                  color="info"
                  label="Seçiniz"
                  placeholder="Seçiniz"
                />
              </Grid>
            </Grid>

            <Grid md={6} xs={6} sx={{ backgroundColor: "#F4F7FE" }}>
              <ByzMuiTypography
                sx={{ display: "flex", textAlign: "center" }}
                fontWeight={500}
                fontSize={"14px"}
              >
                6 - Motor(Bacaklar) Yatarak 30° (5 Sn Havada Tutulur)
              </ByzMuiTypography>
            </Grid>

            <Grid
              container
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              <Grid md={6} xs={6} sx={{ borderBottom: "1px solid #E0E0E0" }}>
                <ByzMuiTypography>6a - Motor Sol Bacak</ByzMuiTypography>
              </Grid>

              <Grid md={6} xs={6}>
                <ByzMuiSelect
                  renderInput={(params) => (
                    <ByzMuiTextField
                      {...params}
                      label="Ortalama Arter Basıncı"
                      variant="outlined"
                    />
                  )}
                  options={[]}
                  sx={{ width: "235px" }}
                  color="info"
                  label="Seçiniz"
                  placeholder="Seçiniz"
                />
              </Grid>
            </Grid>

            <Grid
              container
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              <Grid md={6} xs={6} sx={{ borderBottom: "1px solid #E0E0E0" }}>
                <ByzMuiTypography>6b - Motor Sağ Bacak</ByzMuiTypography>
              </Grid>

              <Grid md={6} xs={6}>
                <ByzMuiSelect
                  renderInput={(params) => (
                    <ByzMuiTextField
                      {...params}
                      label="Ortalama Arter Basıncı"
                      variant="outlined"
                    />
                  )}
                  options={[]}
                  sx={{ width: "235px" }}
                  color="info"
                  label="Seçiniz"
                  placeholder="Seçiniz"
                />
              </Grid>
            </Grid>

            <Grid
              container
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              <Grid md={6} xs={6} sx={{ borderBottom: "1px solid #E0E0E0" }}>
                <ByzMuiTypography sx={{ display: "flex", textAlign: "left" }}>
                  7 - Ataksisi
                </ByzMuiTypography>
              </Grid>

              <Grid md={6} xs={6}>
                <ByzMuiSelect
                  renderInput={(params) => (
                    <ByzMuiTextField
                      {...params}
                      label="Ortalama Arter Basıncı"
                      variant="outlined"
                    />
                  )}
                  options={[]}
                  sx={{ width: "235px" }}
                  color="info"
                  label="Seçiniz"
                  placeholder="Seçiniz"
                />
              </Grid>
            </Grid>

            <Grid
              container
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              <Grid md={6} xs={6} sx={{ borderBottom: "1px solid #E0E0E0" }}>
                <ByzMuiTypography sx={{ display: "flex", textAlign: "left" }}>
                  8 - Duyu
                </ByzMuiTypography>
              </Grid>

              <Grid md={6} xs={6}>
                <ByzMuiSelect
                  renderInput={(params) => (
                    <ByzMuiTextField
                      {...params}
                      label="Ortalama Arter Basıncı"
                      variant="outlined"
                    />
                  )}
                  options={[]}
                  sx={{ width: "235px" }}
                  color="info"
                  label="Seçiniz"
                  placeholder="Seçiniz"
                />
              </Grid>
            </Grid>

            <Grid
              container
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              <Grid md={6} xs={6} sx={{ borderBottom: "1px solid #E0E0E0" }}>
                <ByzMuiTypography sx={{ display: "flex", textAlign: "left" }}>
                  9 - Konuşma (Resim ve Metinler Kullan)
                </ByzMuiTypography>
              </Grid>

              <Grid md={6} xs={6}>
                <ByzMuiSelect
                  renderInput={(params) => (
                    <ByzMuiTextField
                      {...params}
                      label="Ortalama Arter Basıncı"
                      variant="outlined"
                    />
                  )}
                  options={[]}
                  sx={{ width: "235px" }}
                  color="info"
                  label="Seçiniz"
                  placeholder="Seçiniz"
                />
              </Grid>
            </Grid>

            <Grid
              container
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              <Grid md={6} xs={6} sx={{ borderBottom: "1px solid #E0E0E0" }}>
                <ByzMuiTypography sx={{ display: "flex", textAlign: "left" }}>
                  10 - Dizartri (Kelimeleri Kullan)
                </ByzMuiTypography>
              </Grid>

              <Grid md={6} xs={6}>
                <ByzMuiSelect
                  renderInput={(params) => (
                    <ByzMuiTextField
                      {...params}
                      label="Ortalama Arter Basıncı"
                      variant="outlined"
                    />
                  )}
                  options={[]}
                  sx={{ width: "235px" }}
                  color="info"
                  label="Seçiniz"
                  placeholder="Seçiniz"
                />
              </Grid>
            </Grid>

            <Grid
              container
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              <Grid md={6} xs={6} sx={{ borderBottom: "1px solid #E0E0E0" }}>
                <ByzMuiTypography sx={{ display: "flex", textAlign: "left" }}>
                  11 - İhmal
                </ByzMuiTypography>
              </Grid>

              <Grid md={6} xs={6}>
                <ByzMuiSelect
                  renderInput={(params) => (
                    <ByzMuiTextField
                      {...params}
                      label="Ortalama Arter Basıncı"
                      variant="outlined"
                    />
                  )}
                  options={[]}
                  sx={{ width: "235px" }}
                  color="info"
                  label="Seçiniz"
                  placeholder="Seçiniz"
                />
              </Grid>
            </Grid>

            <Grid md={6} xs={6} sx={{ backgroundColor: "#F4F7FE" }}>
              <ByzMuiTypography
                sx={{ display: "flex", textAlign: "center" }}
                fontWeight={500}
                fontSize={"14px"}
              >
                Diğer
              </ByzMuiTypography>
            </Grid>

            <Grid
              container
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              <Grid md={6} xs={6} sx={{ borderBottom: "1px solid #E0E0E0" }}>
                <ByzMuiTypography>Not</ByzMuiTypography>
              </Grid>

              <Grid md={6} xs={6}>
                <ByzMuiTextField
                  id="outlined-basic"
                  label=""
                  variant="outlined"
                  sx={{ width: "300px" }}
                />
              </Grid>
            </Grid>

            <Grid
              container
              alignItems={"center"}
              justifyContent={"space-between"}
            >
              <Grid md={6} xs={6} sx={{ borderBottom: "1px solid #E0E0E0" }}>
                <ByzMuiTypography>Skor</ByzMuiTypography>
              </Grid>

              <Grid md={6} xs={6}>
                <ByzMuiTextField
                  id="outlined-basic"
                  label=""
                  variant="outlined"
                  sx={{ width: "300px", backgroundColor: "#F5F5F5" }}
                  disabled
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </>
  );
}

export default NihssScoreCreate;
